/**
 * Format a decimal quantity for display, dropping the trailing zeros the API's fixed-scale
 * strings carry ("10.000" → "10", "12.500" → "12.5").
 */
export default function formatQuantity(value: number | string): string {
    return String(Number(value))
}
